import { useState, useEffect } from "react";
import { fieldType } from "../../../../types/form";
import Datepicker from "react-tailwindcss-datepicker";
import { TGDisclosure } from "../../TGDisclosure";
import { SubResetFilter } from "src/pages/DashboardPage/mytasks/meetingsPage/components/MeetingCard";
import moment from "moment";
import { twMerge } from "tailwind-merge";

type Props = {
  dataField: fieldType;
  onChange: (data: any) => void;
  value: any;
  errors?: any;
  type: string;
};

function DateRangeField(props: Props) {
  const { dataField, onChange, value, errors, type } = props;
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  useEffect(() => {
    if (dataField.default) {
      onChange(dataField.default);
    }
  }, [dataField]);

  useEffect(() => {
    const today = moment();
    const isMonday = today.isoWeekday() === 1;
    setStartDate(
      (isMonday &&
        moment()
          .subtract(1, "weeks")
          .startOf("isoWeek")
          .format("YYYY-MM-DD")) ||
      moment().startOf("isoWeek").format("YYYY-MM-DD")
    );
    setEndDate(
      (isMonday &&
        moment().subtract(1, "weeks").endOf("isoWeek").format("YYYY-MM-DD")) ||
      moment().endOf("isoWeek").format("YYYY-MM-DD")
    );
  }, []);

  useEffect(() => {
    if (type === "approvers_replaced") {
      if (value) {
        const start = moment(value.startDate);
        const end = moment(value.endDate);
        const daysInclusive = end.diff(start, "days") + 1;
        if (daysInclusive > 45) {
          onChange(null);
        }
      }
    }
  }, [type, value]);

  return (
    <>
      {(dataField.isFilter && (
        <TGDisclosure
          disabled={dataField.disabled}
          wrapperClassName={dataField.width}
          title={dataField.title}
          count={(value && 1) || 0}
        >
          <div className="mt-2">
            <Datepicker
              inputClassName="text-left cursor-default block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB] translate-x-5"
              useRange={false}
              toggleClassName="absolute right-[-10px] top-0 h-full px-3 text-gray-400 focus:outline-none disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB] buttonDatePicker"
              i18n="ru"
              popoverDirection="down"
              primaryColor="blue"
              startWeekOn={"mon"}
              disabled={dataField.disabled}
              displayFormat="DD.MM.YYYY"
              readOnly={true}
              maxDate={dataField.maxDate}
              minDate={dataField.minDate}
              value={
                value || dataField.default || { startDate: null, endDate: null }
              }
              onChange={(value: any) => {
                if (value.startDate === null || value.endDate === null) {
                  onChange(null);
                } else {
                  onChange(value);
                }
              }}
              placeholder={dataField.placeholder}
              containerClassName={`-translate-x-5 relative ${dataField.key === 'DateIncidents' ? "z-20" : "z-10"} tg-datepicker-center-mobile`}
            />
          </div>
          {dataField.notice && (
            <div className="text-sm text-[#6B7280]">{dataField.notice}</div>
          )}
          <SubResetFilter
            resetFilter={() =>
              onChange(
                dataField.key === "DateForRevision" ||
                  dataField.key === "ClosedDate" ||
                  dataField.key === "DateIncidents2"
                  ? null
                  : {
                    startDate,
                    endDate,
                  }
              )
            }
          />
        </TGDisclosure>
      )) || (
          <div className={`${dataField.width} mb-5`}>
            <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
              <span>{dataField.title}</span>
              {dataField.require && (
                <div className="flex flex-row justify-between">
                  {Object.keys(errors).length > 0 && errors[dataField.key] && (
                    <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                  )}
                  <span className="text-[#BA0C2F]">*</span>
                </div>
              )}
            </label>
            <div className="mt-2">
              <Datepicker
                inputClassName="text-left cursor-default block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB] translate-x-5"
                useRange={false}
                toggleClassName="absolute right-[-10px] top-0 h-full px-3 text-gray-400 focus:outline-none disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]"
                i18n="ru"
                popoverDirection="down"
                primaryColor="blue"
                startWeekOn={"mon"}
                disabled={dataField.disabled}
                displayFormat="DD.MM.YYYY"
                readOnly={true}
                maxDate={dataField.maxDate}
                minDate={dataField.minDate}
                value={
                  value || dataField.default || { startDate: null, endDate: null }
                }
                onChange={onChange}
                placeholder={dataField.placeholder}
                containerClassName="-translate-x-5 relative z-10 tg-datepicker-center-mobile"
              />
            </div>
            {dataField.notice && (
              <div className="text-sm text-[#6B7280]">{dataField.notice}</div>
            )}
          </div>
        )}
    </>
  );
}

export default DateRangeField;
